module.exports = __webpack_public_path__ + "img/logo2.352ae019.png";